const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "84.1006 173.7924 100.6624 20",
    width: "100.662px",
    height: "20px",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "matrix(0.1415029913187027, 0, 0, 0.1415029913187027, 125.82652657707101, 154.38628084618676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "matrix(1, 0, 0, 1, -294.876474, 137.143147)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m148.68,41.78l-10.61-37.03L111.11,0l7.97,45.2c-7.92.57-15.92.85-23.98.85s-16.06-.28-23.97-.85L79.1,0l-26.94,4.75-10.61,37.03c-14.16-2.27-28.03-5.45-41.55-9.46l4.24,30.18c9.7,2.51,19.56,4.62,29.56,6.32,10.67,1.83,21.5,3.18,32.46,4.05,9.52.75,19.14,1.13,28.85,1.13s19.33-.38,28.85-1.13c10.96-.87,21.8-2.22,32.48-4.05,10-1.7,19.86-3.81,29.56-6.32l4.24-30.18c-13.51,4.01-27.38,7.18-41.55,9.46Z",
    style: {
      fill: "rgb(65, 55, 152)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.92,80.47l-10.73,60.86-33.2-27.85,10.67-37.21c10.93,1.9,22.02,3.3,33.26,4.2Z",
    style: {
      fill: "rgb(65, 55, 152)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m169.24,113.47l-33.2,27.86-10.74-60.86c11.24-.9,22.34-2.32,33.27-4.2l10.67,37.2Z",
    style: {
      fill: "rgb(65, 55, 152)",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.27,28.31h17.98v47.84h68.23V28.31h17.98v113.02h-17.9v-47.28h-68.31v47.28h-17.98V28.31Z",
    style: {
      fill: "rgb(9, 17, 26)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m347.27,100.95c0-21.99,15.17-42.54,40.54-40.7,11.16.56,20.47,6.98,25.85,17.5v-16.05h17.82v79.63h-17.82v-17.1c-5.7,10.92-14.69,16.13-25.85,16.86-25.28,2.81-40.54-18.94-40.54-40.13Zm41.58,24c14.29,0,23.6-10.35,23.6-24s-9.07-24.32-23.6-24.32-23.76,9.87-23.76,24.32c0,13.65,9.39,24,23.76,24Z",
    style: {
      fill: "rgb(9, 17, 26)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m444.64,61.7h17.98v10.92c3.85-6.98,12.76-12.12,21.35-12.36,20.95-.8,35.32,13.41,35.32,37.32v43.75h-18.06v-43.59c0-14.37-8.51-20.95-19.26-20.95s-19.43,7.79-19.43,19.1v45.44h-17.98l.08-79.63Z",
    style: {
      fill: "rgb(9, 17, 26)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m531.09,115.64h17.9c.24,5.14,4.25,7.95,9.87,7.95,4.82,0,8.83-3.21,8.67-7.71-.24-5.86-7.3-7.22-16.21-10.52-9.95-3.69-20.07-7.22-20.07-22.23,0-13.89,13.08-23.36,27.29-23.36,14.93,0,27.53,10.76,27.53,25.53l-17.5.08c-.4-4.98-3.61-8.83-9.79-8.83-5.22,0-9.87,2.97-9.87,7.79,0,6.9,6.98,8.51,13.89,10.35,8.43,2.33,23.84,6.9,23.28,24.72-.4,13.08-12.44,21.67-26.81,21.67-15.09,0-28.17-10.35-28.17-25.45Z",
    style: {
      fill: "rgb(9, 17, 26)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m599.41,28.31h18.14v46.48c4.09-9.15,14.85-14.29,23.44-14.53,22.72-.8,37.65,15.81,37.65,40.78v40.3h-18.22v-40.3c0-14.85-7.87-24.16-21.43-24.16-10.84,0-21.43,8.59-21.43,20.71v43.75h-18.14V28.31Z",
    style: {
      fill: "rgb(9, 17, 26)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m701.43,28.31c5.62,0,9.95,4.5,9.95,9.95s-4.33,9.95-9.95,9.95-9.79-4.58-9.79-9.95,4.33-9.95,9.79-9.95Zm-8.59,33.39h17.98v79.63h-17.9l-.08-79.63Z",
    style: {
      fill: "rgb(9, 17, 26)",
      strokeWidth: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSm);
export default __webpack_public_path__ + "static/media/full-sm.74dd60f9946f7645f141ec3c225ddb0e.svg";
export { ForwardRef as ReactComponent };